import { CheckCircle2, Cpu, Ruler, Snowflake, Volume2, Phone, ArrowRight, Palette } from "lucide-react";
import { Link } from "@/components/common/Link";
const NAVY = "#081438";
const NAVY_DEEP = "#050D24";
const NAVY_LIGHT = "#243752";
const GOLD = "#F5A623";
const GOLD_DARK = "#9A6400";
const FONT_HEAD = "'Plus Jakarta Sans', system-ui, sans-serif";
const FONT_BODY = "'Manrope', system-ui, sans-serif";
const MODELS = [{
  wordmark: "B&D",
  model: "Panelift Icon Insulated",
  type: "Sectional",
  pattern: "Classic horizontal ribbed",
  thickness: "42 mm",
  rValue: "R-2.0",
  db: "27 dB",
  bestFor: "The default upgrade. Suits 90% of suburban Sydney homes. Strong ColorBond range, well-priced, fast lead time.",
  swatches: ["#3F4045", "#E4DBC4", "#7A8A92", "#43545C", "#A0998C"],
  swatchLabel: "Surfmist · Monument · Shale · Basalt + more",
  featured: true
}, {
  wordmark: "STEEL-LINE",
  model: "Therma-Lux Premium",
  type: "Sectional",
  pattern: "Smooth flat panel",
  thickness: "45 mm",
  rValue: "R-2.2",
  db: "29 dB",
  bestFor: "Architectural / contemporary homes. Smooth-skin look, deeper core, premium acoustic. Great for media rooms above.",
  swatches: ["#1A1A1A", "#FFFFFF", "#564E47", "#8B7C70", "#3F4045"],
  swatchLabel: "Night Sky · Surfmist · Woodland Grey + more",
  featured: false
}, {
  wordmark: "CENTURION",
  model: "ThermaShield Insulated",
  type: "Sectional",
  pattern: "Cassette-style with windows option",
  thickness: "40 mm",
  rValue: "R-1.9",
  db: "26 dB",
  bestFor: "Coastal &amp; salt-air zones — marine-grade hardware, EPDM seals, stronger corrosion warranty. Beachside Sydney's choice.",
  swatches: ["#E4DBC4", "#9CA09C", "#3F4045", "#5E6F6E", "#C9B59F"],
  swatchLabel: "Surfmist · Wallaby · Monument + more",
  featured: false
}, {
  wordmark: "Gliderol",
  model: "Insulated Roller Door",
  type: "Roller",
  pattern: "Foam-backed slats",
  thickness: "20 mm slat",
  rValue: "R-1.2",
  db: "22 dB",
  bestFor: "Low-headroom &amp; tight garages where sectional won't fit. Apartment carparks, narrow inner-west homes, granny flats.",
  swatches: ["#E4DBC4", "#7A8A92", "#43545C", "#A89F92", "#3F4045"],
  swatchLabel: "Available in full ColorBond palette",
  featured: false
}];
export default function InsulatedRange() {
  return <section className="relative overflow-hidden" style={{
    backgroundColor: NAVY,
    fontFamily: FONT_BODY,
    paddingTop: "110px",
    paddingBottom: "110px"
  }}>
      {}
      <div aria-hidden className="absolute inset-0" style={{
      background: `radial-gradient(circle at 80% 20%, ${NAVY_LIGHT}66 0%, ${NAVY} 50%), radial-gradient(circle at 10% 100%, ${GOLD}10 0%, transparent 40%)`
    }} />

      {}
      <div aria-hidden className="absolute inset-0 opacity-[0.05] pointer-events-none" style={{
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='160' height='160'%3E%3Cfilter id='n'%3E%3CfeTurbulence baseFrequency='0.9'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.6'/%3E%3C/svg%3E\")"
    }} />

      {}
      <div aria-hidden className="absolute top-0 left-0 right-0 h-px" style={{
      background: `linear-gradient(90deg, transparent, ${GOLD}66 50%, transparent)`
    }} />

      {}
      <div aria-hidden className="absolute pointer-events-none select-none" style={{
      right: "-30px",
      top: "60px",
      fontFamily: FONT_HEAD,
      fontSize: "240px",
      fontWeight: 800,
      lineHeight: 1,
      letterSpacing: "-0.05em",
      color: `${GOLD}12`
    }}>
        05
      </div>

      <div className="relative max-w-[1280px] mx-auto px-6 lg:px-10">
        {}
        <div className="mb-14 max-w-3xl">
          <div className="mb-5 flex items-center gap-3">
            <div aria-hidden className="h-px w-12" style={{
            backgroundColor: GOLD
          }} />
            <span style={{
            fontFamily: FONT_HEAD,
            fontSize: "12px",
            fontWeight: 700,
            letterSpacing: "0.22em",
            textTransform: "uppercase",
            color: GOLD
          }}>
              05 · The Range We Install
            </span>
          </div>

          <h2 style={{
          fontFamily: FONT_HEAD,
          fontWeight: 800,
          fontSize: "clamp(2.1rem, 4vw, 3.4rem)",
          lineHeight: 1.08,
          letterSpacing: "-0.025em",
          color: "#ffffff",
          marginBottom: "20px"
        }}>
            Four models.
            <br />
            <span style={{
            color: GOLD
          }}>
              One that fits your home.
            </span>
          </h2>

          <p style={{
          fontFamily: FONT_BODY,
          fontSize: "17px",
          lineHeight: 1.65,
          color: "rgba(255,255,255,0.72)",
          maxWidth: "640px"
        }}>
            We supply and install the four most-fitted insulated doors in
            Sydney — sectional, roller, smooth, ribbed, beachside-spec. Tell
            us your situation; we'll match the model.
          </p>
        </div>

        {}
        <div className="grid md:grid-cols-2 gap-5">
          {MODELS.map((m, i) => <article key={m.model} data-index={i} className="relative rounded-2xl overflow-hidden transition-all hover:translate-y-[-2px] hover:shadow-2xl" style={{
          backgroundColor: `${NAVY_LIGHT}55`,
          border: m.featured ? `1px solid ${GOLD}55` : `1px solid rgba(255,255,255,0.08)`,
          boxShadow: m.featured ? `0 20px 50px rgba(0,0,0,0.4), 0 0 0 1px ${GOLD}33` : "none",
          backdropFilter: "blur(6px)"
        }}>
              {}
              <div aria-hidden className="absolute top-0 left-0 h-px" style={{
            width: "80px",
            background: `linear-gradient(90deg, ${GOLD} 0%, transparent 100%)`
          }} />
              <div aria-hidden className="absolute top-0 left-0 w-px" style={{
            height: "80px",
            background: `linear-gradient(180deg, ${GOLD} 0%, transparent 100%)`
          }} />

              {}
              <div aria-hidden className="absolute bottom-4 right-6 pointer-events-none select-none" style={{
            fontFamily: FONT_HEAD,
            fontSize: "60px",
            fontWeight: 800,
            color: `${GOLD}10`,
            lineHeight: 1,
            letterSpacing: "-0.04em"
          }}>
                {String(i + 1).padStart(2, "0")}
              </div>

              <div className="p-7 md:p-8 relative">
                {}
                {m.featured && <div className="absolute" style={{
              top: "24px",
              right: "24px",
              padding: "4px 10px",
              borderRadius: "999px",
              background: `linear-gradient(135deg, ${GOLD} 0%, ${GOLD_DARK} 100%)`,
              color: NAVY,
              fontFamily: FONT_HEAD,
              fontSize: "9px",
              fontWeight: 900,
              letterSpacing: "0.16em",
              textTransform: "uppercase",
              boxShadow: `0 4px 12px ${GOLD}55`
            }}>
                     Best seller
                  </div>}

                {}
                <div className="mb-5">
                  <div style={{
                fontFamily: FONT_HEAD,
                fontWeight: 900,
                fontSize: "1.6rem",
                letterSpacing: "-0.025em",
                color: "#ffffff",
                lineHeight: 1.1,
                marginBottom: "6px"
              }}>
                    {m.wordmark}
                  </div>
                  <div className="flex items-center gap-2 flex-wrap">
                    <span style={{
                  fontFamily: FONT_HEAD,
                  fontSize: "14px",
                  fontWeight: 700,
                  color: GOLD,
                  letterSpacing: "-0.01em"
                }}>
                      {m.model}
                    </span>
                    <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md" style={{
                  backgroundColor: `${GOLD}15`,
                  border: `1px solid ${GOLD}33`
                }}>
                      <span style={{
                    fontFamily: FONT_HEAD,
                    fontSize: "9.5px",
                    fontWeight: 700,
                    color: GOLD,
                    letterSpacing: "0.1em",
                    textTransform: "uppercase"
                  }}>
                        {m.type}
                      </span>
                    </span>
                  </div>
                </div>

                {}
                <div className="mb-5 pb-5 border-b flex items-center gap-2" style={{
              borderColor: "rgba(255,255,255,0.1)"
            }}>
                  <span style={{
                fontFamily: FONT_HEAD,
                fontSize: "10px",
                fontWeight: 700,
                letterSpacing: "0.14em",
                textTransform: "uppercase",
                color: "rgba(255,255,255,0.5)"
              }}>
                    Pattern:
                  </span>
                  <span style={{
                fontFamily: FONT_BODY,
                fontSize: "13px",
                color: "rgba(255,255,255,0.85)",
                fontWeight: 500
              }}>
                    {m.pattern}
                  </span>
                </div>

                {}
                <div className="flex flex-wrap gap-2 mb-5">
                  <div className="inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-md" style={{
                backgroundColor: `${GOLD}12`,
                border: `1px solid ${GOLD}33`
              }}>
                    <span aria-hidden data-icon-container="lucide-do-not-replace" className="inline-flex">
                      <Ruler size={11} color={GOLD} strokeWidth={2.5} />
                    </span>
                    <span style={{
                  fontFamily: FONT_HEAD,
                  fontSize: "11px",
                  fontWeight: 700,
                  color: "#ffffff"
                }}>
                      {m.thickness}
                    </span>
                  </div>
                  <div className="inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-md" style={{
                backgroundColor: `${GOLD}12`,
                border: `1px solid ${GOLD}33`
              }}>
                    <span aria-hidden data-icon-container="lucide-do-not-replace" className="inline-flex">
                      <Snowflake size={11} color={GOLD} strokeWidth={2.5} />
                    </span>
                    <span style={{
                  fontFamily: FONT_HEAD,
                  fontSize: "11px",
                  fontWeight: 700,
                  color: "#ffffff"
                }}>
                      {m.rValue}
                    </span>
                  </div>
                  <div className="inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-md" style={{
                backgroundColor: `${GOLD}12`,
                border: `1px solid ${GOLD}33`
              }}>
                    <span aria-hidden data-icon-container="lucide-do-not-replace" className="inline-flex">
                      <Volume2 size={11} color={GOLD} strokeWidth={2.5} />
                    </span>
                    <span style={{
                  fontFamily: FONT_HEAD,
                  fontSize: "11px",
                  fontWeight: 700,
                  color: "#ffffff"
                }}>
                      {m.db}
                    </span>
                  </div>
                </div>

                {}
                <div className="mb-5">
                  <div style={{
                fontFamily: FONT_HEAD,
                fontSize: "10px",
                fontWeight: 700,
                letterSpacing: "0.14em",
                textTransform: "uppercase",
                color: "rgba(255,255,255,0.5)",
                marginBottom: "6px"
              }}>
                    Best for
                  </div>
                  <p style={{
                fontFamily: FONT_BODY,
                fontSize: "13.5px",
                lineHeight: 1.55,
                color: "rgba(255,255,255,0.78)"
              }} dangerouslySetInnerHTML={{
                __html: m.bestFor
              }} />
                </div>

                {}
                <div className="mb-1">
                  <div className="flex items-center gap-2 mb-2.5">
                    <span aria-hidden data-icon-container="lucide-do-not-replace" className="inline-flex">
                      <Palette size={11} color={GOLD} strokeWidth={2.5} />
                    </span>
                    <span style={{
                  fontFamily: FONT_HEAD,
                  fontSize: "10px",
                  fontWeight: 700,
                  letterSpacing: "0.14em",
                  textTransform: "uppercase",
                  color: GOLD
                }}>
                      ColorBond palette
                    </span>
                  </div>
                  <div className="flex items-center gap-2 mb-2">
                    {m.swatches.map((c, ci) => <span key={ci} aria-hidden className="inline-block rounded-lg" style={{
                  width: 22,
                  height: 22,
                  backgroundColor: c,
                  border: `1.5px solid rgba(255,255,255,0.25)`,
                  boxShadow: "0 2px 6px rgba(0,0,0,0.3)"
                }} />)}
                  </div>
                  <p style={{
                fontFamily: FONT_BODY,
                fontSize: "11px",
                color: "rgba(255,255,255,0.5)",
                fontStyle: "italic"
              }}>
                    {m.swatchLabel}
                  </p>
                </div>

                {}
                <div className="mt-5 pt-4 border-t flex items-center gap-2" style={{
              borderColor: "rgba(255,255,255,0.08)"
            }}>
                  <span aria-hidden data-icon-container="lucide-do-not-replace" className="inline-flex">
                    <CheckCircle2 size={13} color={GOLD} strokeWidth={2.5} />
                  </span>
                  <span style={{
                fontFamily: FONT_HEAD,
                fontSize: "11px",
                fontWeight: 700,
                letterSpacing: "0.12em",
                textTransform: "uppercase",
                color: GOLD
              }}>
                    We supply &amp; install
                  </span>
                </div>
              </div>
            </article>)}
        </div>

        {}
        <div className="mt-12 rounded-2xl p-7 md:p-8 relative overflow-hidden" style={{
        background: `linear-gradient(135deg, ${NAVY_LIGHT}AA 0%, ${NAVY_DEEP} 100%)`,
        border: `1px solid ${GOLD}33`
      }}>
          <div className="relative flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
            <div className="flex items-start gap-4">
              <span aria-hidden data-icon-container="lucide-do-not-replace" className="inline-flex items-center justify-center rounded-lg flex-shrink-0" style={{
              width: 52,
              height: 52,
              backgroundColor: `${GOLD}20`,
              border: `1px solid ${GOLD}44`
            }}>
                <Cpu size={22} color={GOLD} strokeWidth={2.5} />
              </span>
              <div>
                <div style={{
                fontFamily: FONT_HEAD,
                fontSize: "11px",
                fontWeight: 700,
                letterSpacing: "0.2em",
                textTransform: "uppercase",
                color: GOLD,
                marginBottom: "4px"
              }}>
                  Custom or specialty
                </div>
                <h3 style={{
                fontFamily: FONT_HEAD,
                fontWeight: 800,
                fontSize: "clamp(1.3rem, 2vw, 1.7rem)",
                lineHeight: 1.2,
                color: "#ffffff",
                letterSpacing: "-0.015em"
              }}>
                  Have an architect spec or unusual opening size?
                </h3>
              </div>
            </div>

            <Link to="tel:0485000933" className="inline-flex items-center gap-2.5 px-6 py-3.5 rounded-lg transition-all hover:scale-[1.02] flex-shrink-0" style={{
            backgroundColor: GOLD,
            color: NAVY,
            fontFamily: FONT_HEAD,
            fontWeight: 700,
            fontSize: "14px",
            boxShadow: `0 8px 24px ${GOLD}33`
          }}>
              <span aria-hidden data-icon-container="lucide-do-not-replace" className="inline-flex">
                <Phone size={16} strokeWidth={2.5} />
              </span>
              Talk specs
              <span aria-hidden data-icon-container="lucide-do-not-replace" className="inline-flex">
                <ArrowRight size={14} strokeWidth={2.5} />
              </span>
            </Link>
          </div>
        </div>
      </div>

      {}
      <div aria-hidden className="absolute bottom-0 left-0 right-0 h-px" style={{
      background: `linear-gradient(90deg, transparent, ${GOLD}66 50%, transparent)`
    }} />
    </section>;
}